<div class="service-price__header">
  <app-service-reviews [game]="service.game" [type]="'solo'" [service]="'divisions'" [current]="service.desired"></app-service-reviews>
</div>

<div class="service-price__content">
  <div class="checkout-images">
    <img [style.top]="charactersTop[campaign==='default' ? 'default' : 'campaign'][service.game+'-right']+'px'" [className]="'character-right'"
      [src]="cdnUrl + '/campaigns/' + campaign + '/characters/' + service.game + '-right.webp'"
      [alt]="service.game + ' character right purchase boost '+campaign+' discount'">
    <img [style.top]="charactersTop[campaign==='default' ? 'default' : 'campaign'][service.game+'-left']+'px'" [className]="'character-left'"
      [src]="cdnUrl + '/campaigns/' + campaign + '/characters/' + service.game + '-left.webp'"
      [alt]="service.game + ' character left purchase boost '+campaign+' discount'">
  </div>

  <ngx-loading [show]="isPriceLoading"></ngx-loading>

  <!-- SERVICE TITLE -->
  <div class="service-price__content-section" style="padding: 0.8rem;">
    <p class="service-price__content-section-title text-bj">
      {{serviceTitle}}
    </p>
    <p class="service-price__order-details">
      <span [innerHTML]="title | safe: 'html'"></span>
    </p>
  </div>

  <!-- SOLO / DUO -->
  <div class="fancy c2">
    <div (click)="selectDuo(isDuoAvailable)" class="switch2 left c2"
      [ngClass]="{'faded': service.type === 'solo', 'disabled': !isDuoAvailable}" style="--i: #e7283c; --f: #e74b3c; --a: #e397a0; --d: #a9a9a9; --h: #e77179;">
      <div *ngIf="isDuoAvailable" class="tooltip-on-hover">
        <h4>{{ 'duo' | translate: lang }}</h4>
        <p style="font-size:11px">{{ 'duo_desc' | translate: lang }}</p>
      </div>
      <div *ngIf="!isDuoAvailable" class="tooltip-on-hover">
        <h4>{{ 'duo' | translate: lang }}</h4>
        <p style="font-size:11px">{{ 'not_available' | translate: lang }}</p>
      </div>
    </div>
    <div (click)="selectSolo(isSoloAvailable)" class="switch2 right c2 gg-slider"
      [ngClass]="{'faded': service.type === 'duo', 'disabled': !isSoloAvailable}" style="--i: #347bdb; --f: #1c61c2; --a: #99B4ED; --d: #a9a9a9; --h: #5c89e7;">
      <div *ngIf="isSoloAvailable">
        <h4>{{ 'solo' | translate: lang }}</h4>
        <p style="font-size:11px">{{ 'solo_desc' | translate: lang }}</p>
      </div>
      <div *ngIf="!isSoloAvailable">
        <h4>{{ 'solo' | translate: lang }}</h4>
        <p style="font-size:11px">{{ 'not_available' | translate: lang }}</p>
      </div>
    </div>
  </div>

  <!-- OFFLINE / ELEMENTS OF COACHING -->
  <div *ngIf="isBrowser && service.type === 'solo'" class="service-price__content-section --additions">
    <p class="tt">
      {{ 'offline_vpn' | translate: lang }}
      <span class="tooltiptext">
        {{ 'offline_tooltip' | translate: lang }}
      </span>

      <small>{{ 'free' | translate: lang }}</small>
      <label class="switch float-right">
        <input disabled [checked]="true" class="isExpress" type="checkbox">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <div *ngIf="isBrowser && service.type === 'duo'" class="service-price__content-section --additions">
    <p class="tt">
      {{ 'coaching' | translate: lang }}
      <span class="tooltiptext">
        {{ 'coaching_tooltip' | translate: lang }}
      </span>

      <small>{{ 'free' | translate: lang }}</small>
      <label class="switch float-right">
        <input disabled [checked]="true" class="isExpress" type="checkbox">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <!-- ROLES -->
  <div *ngIf="isBrowser && ((service.game === 'lol' || service.game === 'wild-rift') && service.service !== 'masteries') || service.game === 'valorant' || (service.game === 'apex' && service.service !== 'badges') || service.game === 'marvel'" class="service-price__content-section --additions">
    <p class="tt">
      {{ 'choose_roles' | translate: lang }}
      <span class="tooltiptext">
        {{ (service.type === 'solo' ? 'choose_roles_tooltip_solo' : 'roles_tooltip') | translate: lang }}
      </span>

      <small>{{ 'free' | translate: lang }}</small>
      <span *ngIf="isRolesCustomizationOn" class="edit-pencil" (click)="showRolesCustomization()">
        <img src="https://cdn.ggboost.com/images/icons/edit-small.png">
      </span>

      <label class="switch float-right">
        <input [checked]="isRolesCustomizationOn" class="isExpress" type="checkbox" (change)="toggleRolesCustomization()">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <!-- CHAMPS / HEROES / AGENTS & ROLES -->
  <div *ngIf="isBrowser && (service.game === 'lol' || service.game === 'wild-rift')  && service.service !== 'masteries' && allowChampions" class="service-price__content-section --additions">
    <p class="tt">
      {{ 'choose_champions' | translate: lang }}
      <span class="tooltiptext">
        {{ (service.type === 'solo' ? 'choose_champions_tooltip_solo' : 'choose_champions_tooltip') | translate: lang }}
      </span>

      <small [ngClass]="{'paid':(customization.characters.length >= 1 && customization.characters.length <= 3  && service.type === 'solo')}">{{ customization.characters.length >= 1 && customization.characters.length <= 3  && service.type === 'solo' ? '+10%' : ('free' | translate: lang) }}</small>
      <span *ngIf="isWithCharacters" class="edit-pencil" (click)="showLolCustomization(service.game)">
      <img src="https://cdn.ggboost.com/images/icons/edit-small.png">
    </span>

    <label class="switch float-right">
      <input [checked]="isWithCharacters" class="isExpress" type="checkbox" (change)="onToggleCustomization()">
      <span class="slider"></span>
    </label>
    </p>
  </div>

  <div *ngIf="isBrowser && service.game === 'valorant'" class="service-price__content-section --additions">
    <p class="tt">
      {{ 'choose_agents' | translate: lang }}
      <span class="tooltiptext">
        {{ (service.type === 'solo' ? 'choose_agents_tooltip_solo' : 'agents_tooltip') | translate: lang }}
      </span>

      <small>{{ 'free' | translate: lang }}</small>
      <span *ngIf="isWithCharacters" class="edit-pencil" (click)="showValorantCustomization()">
        <img src="https://cdn.ggboost.com/images/icons/edit-small.png">
      </span>

      <label class="switch float-right">
        <input [checked]="isWithCharacters" class="isExpress" type="checkbox" (change)="onToggleCustomization()">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <div *ngIf="isBrowser && service.game === 'apex' && service.service !== 'badges'" class="service-price__content-section --additions">
    <p class="tt">
      {{ 'choose_legends' | translate: lang }}
      <span class="tooltiptext">
        {{ (service.type === 'solo' ? 'choose_legends_tooltip_solo' : 'choose_legends_tooltip') | translate: lang }}
      </span>

      <small>{{ 'free' | translate: lang }}</small>
      <span *ngIf="isWithCharacters" class="edit-pencil" (click)="showGameCharacterSelect()">
        <img src="https://cdn.ggboost.com/images/icons/edit-small.png">
      </span>

      <label class="switch float-right">
        <input [checked]="isWithCharacters" class="isExpress" type="checkbox" (change)="onToggleCustomization()">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <div *ngIf="isBrowser && service.game === 'marvel'" class="service-price__content-section --additions">
    <p class="tt">
      {{ 'choose_heroes' | translate: lang }}
      <span class="tooltiptext">
        {{ (service.type === 'solo' ? 'choose_heroes_tooltip_solo' : 'choose_heroes_tooltip') | translate: lang }}
      </span>

      <small>{{ 'free' | translate: lang }}</small>
      <span *ngIf="isWithCharacters" class="edit-pencil" (click)="showGameCharacterSelect()">
        <img src="https://cdn.ggboost.com/images/icons/edit-small.png">
      </span>

      <label class="switch float-right">
        <input [checked]="isWithCharacters" class="isExpress" type="checkbox" (change)="onToggleCustomization()">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <!-- <div *ngIf="service.game === 'apex' && service.service !== 'badges'" class="service-price__content-section --additions">
    <p class="tt">
      {{ 'choose_legends' | translate: lang }}
      <span class="tooltiptext" *ngIf="service.type == 'duo'">
        {{ 'choose_legends_tooltip' | translate: lang }}
      </span>

      <small>{{ customization.characters.length >= 1 && customization.characters.length <= 3  && service.type === 'solo' ? '+10%' : 'Free' }}</small>
      <span *ngIf="isWithCharacters" class="edit-pencil" (click)="showValorantCustomization()">
        <img src="https://cdn.ggboost.com/images/icons/edit-small.png">
      </span>

      <label class="switch float-right">
        <input [checked]="isWithCharacters" class="isExpress" type="checkbox" (change)="onToggleCustomization()">
        <span class="slider"></span>
      </label>
    </p>
  </div> -->

  <!-- <div *ngIf="service.game === 'overwatch'" class="service-price__content-section --additions">
    <p class="tt">
      {{ 'choose_heroes' | translate: lang }}
        <span class="tooltiptext" *ngIf="service.type == 'duo'">
          {{ 'heroes_tooltip' | translate: lang }}
        </span>

      <small>{{ 'free' | translate: lang }}</small>
      <span *ngIf="isWithCharacters" class="edit-pencil" (click)="showValorantCustomization()">
        <img src="https://cdn.ggboost.com/images/icons/edit-small.png">
      </span>

      <label class="switch float-right">
        <input [checked]="isWithCharacters" class="isExpress" type="checkbox" (change)="onToggleCustomization()">
        <span class="slider"></span>
      </label>
    </p>
  </div> -->

  <!-- STREAMING / Voice -->
  <div *ngIf="isBrowser && service.type === 'solo' && service.platform === 'pc' && service.game !== 'wild-rift'" class="service-price__content-section --additions">
    <p class="tt">
      <strong>Streaming</strong>
      <span class="tooltiptext">
        {{ 'streaming_tooltip' | translate: lang }}
      </span>

      <small class="paid">+{{ extraServiceStreamingTax }}%</small>
      <label class="switch float-right">
        <input [checked]="isWithStreaming" class="isExpress" type="checkbox" (change)="toggleStreaming()">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <div *ngIf="isBrowser && service.type === 'duo' && service.game !== 'wild-rift'" class="service-price__content-section --additions">
    <p class="tt">
      <strong>Voice</strong>
      <span class="tooltiptext">
        {{ 'voice_tooltip' | translate: lang }}
      </span>

      <small class="paid">+{{ extraServiceVoiceTax }}%</small>
      <label class="switch float-right">
        <input [checked]="isWithVoice" class="isExpress" type="checkbox" (change)="toggleVoice()">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <!-- SOLO ONLY -->
  <div *ngIf="isBrowser && service.type === 'solo'" class="service-price__content-section --additions">
    <p class="tt">
      <strong>{{ 'solo_only' | translate: lang }}</strong>
      <span class="tooltiptext">
        {{ 'solo_only_tooltip' | translate: lang }}
      </span>

      <small class="paid">+{{ extraServiceSoloOnlyTax }}%</small>
      <label class="switch float-right">
        <input [checked]="isSoloOnly" class="isExpress" type="checkbox" (change)="toggleSoloOnly()">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <!-- EXPRESS -->
  <div class="service-price__content-section --additions">
    <p class="tt">
      <strong>{{ 'express_priority' | translate: lang }}</strong>
      <span class="tooltiptext">
        {{ 'express_priority_tooltip' | translate: lang }}
      </span>
      <small class="paid">+25%</small>
      <label class="switch float-right">
        <input [checked]="isExpress" (change)="onToggleExpress()" class="isExpress" type="checkbox">
        <span class="slider"></span>
      </label>
    </p>
  </div>

  <!-- SPENDABLES CREDITS / DISCOUNTS -->
  <div class="service-price__content-section" style="background:#f6f8fa;margin-top:1px" *ngIf="isCreditsAvailable() || availableDiscounts.length">
    <!-- <p style="font-size: 1rem;" class="service-price__content-section-title text-bj">{{ 'use_your_spendables' | translate: lang }}</p> -->
    <ng-container *ngIf="isCreditsAvailable()">
      <ng-container *ngFor="let credit of credits">
        <div class="form-group" *ngIf="currency.toLowerCase() === credit.currency.toLowerCase() && credit.amount > 0">
          <input
            type="checkbox"
            id="credits-{{ credit.currency }}"
            name="checkout-credits"
            class="custom-control-input"
            (change)="onSelectCredits($event, credit.currency)"
          >
          <label class="custom-control-label" for="credits-{{ credit.currency }}">
            <span style="font-size: 0.9rem;"
                  class="text-primary font-weight-bold">{{ 'store_credits' | translate: lang }} > {{ credit.amount | number: '0.2-2' }} {{ credit.currency }}
            </span>
          </label>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="availableDiscounts.length">
      <ng-container *ngFor="let discount of availableDiscounts">
        <div class="form-group">
          <input
            type="checkbox"
            id="credits-{{ discount.id }}"
            name="checkout-credits"
            class="custom-control-input"
            (change)="onSelectDiscount($event, discount.id)"
          >
          <label class="custom-control-label" for="credits-{{ discount.id }}">
            <span style="font-size: 0.9rem;" class="text-primary font-weight-bold">{{ (discount.sku === 'global' ? 'use_global_discount' : 'service_discount') | translate: lang }} > {{ discount.amount }}%
            </span>
          </label>
        </div>
      </ng-container>
    </ng-container>
  </div>

  <!-- PRICE CUSTOMER/BOOSTER -->
  <div *ngIf="!priceError && ( !this.role || this.role === 'booster' || this.role === 'customer' )" class="total-boosting-cost">
    <div class="total-boosting-title">{{ 'total_price' | translate: lang }}</div>
    <div class="sub-total">
      <div class="discount">
        <small>-{{ discount }}%</small>
        <p>{{subtotal | number: '0.2-2'}}  {{currency === 'eur' ? 'EUR' : 'USD'}}</p>
      </div>
      <div class="final-price">{{discountedPrice | number: '0.2-2'}} {{currency === 'eur' ? 'EUR' : 'USD'}}</div>
    </div>
  </div>

  <!-- CASHBACK LEVEL DISPLAY -->
  <div *ngIf="cashback && cashback>0" class="cashback">
    <img src="https://cdn.ggboost.com/images/icons/coins.webp" alt="cashback icon">
    <span>{{ 'youll_earn' | translate: lang }} <strong>{{cashback}} {{currency === 'eur' ? 'EUR' : 'USD'}} cashback!</strong></span>
  </div>

  <!-- VINTAGE DISCOUNTS/CASHBACK DISPLAY -->
  <!-- <div class="progression-container">
    <div [ngClass]="'progression-level ' + ((discountedPrice < 50 && discountedPrice !== 0) ? 'level-selected' : '')" id="level1">
      <div class="amount"><50 {{currency.toUpperCase()}}</div>
      <div class="discount-text">25%<sup class="off">OFF</sup></div>
      <div class="cashback-text">2% Cashback</div>
    </div>
    <div [ngClass]="'progression-level ' + ((discountedPrice > 50 && discountedPrice < 100) ? 'level-selected' : '')" id="level2">
      <div class="amount">>50 {{currency.toUpperCase()}}</div>
      <div class="discount-text">28%<sup class="off">OFF</sup></div>
      <div class="cashback-text">3% Cashback</div>
    </div>
    <div [ngClass]="'progression-level ' + ((discountedPrice > 100 && discountedPrice < 200) ? 'level-selected' : '')" id="level3">
      <div class="amount">>100 {{currency.toUpperCase()}}</div>
      <div class="discount-text">32%<sup class="off">OFF</sup></div>
      <div class="cashback-text">4% Cashback</div>
    </div>
    <div [ngClass]="'progression-level ' + (discountedPrice > 200 ? 'level-selected' : '')" id="level4">
      <div class="amount">>200 {{currency.toUpperCase()}}</div>
      <div class="discount-text">35%<sup class="off">OFF</sup></div>
      <div class="cashback-text">5% Cashback</div>
    </div>
  </div> -->

  <!-- PRICE ADMIN -->
  <div *ngIf="!priceError && this.role && (this.role === 'superadmin' || this.role === 'admin')" class="total-boosting-cost">
    <div class="total-boosting-title">{{ 'total_price' | translate: lang }}</div>
    <div class="sub-total">
      <div class="final-price-admin">{{discountedPrice | number: '0.2-2'}} / {{oldPrice | number: '0.2-2'}} {{currency === 'eur' ? 'EUR' : 'USD'}}</div>
    </div>
  </div>

  <div *ngIf="priceError" class="total-boosting-cost-error">
    {{priceError}}
  </div>

  <!-- OLD BUTTON -->
  <!-- <div class="service-price__content-section --purchase-btn">
    <app-button [classList]="'buy-buttom'"
                [isLoading]="isSubmitting"
                [block]="true"
                [disabled]="priceError"
                (clicked)="buyBoost($event)"
    >{{ 'buy_boost_now' | translate: lang }}
    </app-button>
  </div> -->
  <!--<small style="line-height: 1; text-align: center; margin-top: 4px; font-size:70%">
    By clicking on the button above you agree to our <a routerLink="/terms-of-use" target="_blank" href="">Terms of Use.</a>
  </small>-->
  <div class="service-price__content-section">
    <button class="submit" (click)="buyBoost($event)" [disabled]="priceError || isSubmitting">
      <div>{{ 'buy_boost_now' | translate: lang }}</div>
    </button>
  </div>
</div>

<div class="trustpilot">
  <a class="trustpilot-rating" href="{{ lang !== 'en' ? '/' + lang : ''}}/reviews" target="_blank"
     rel="noopener">
    <p>{{ 'excellent' | translate: lang }}</p>
    <div class="svg-container">
      <svg-selector [svgName]="'green-star-big'"></svg-selector>
      <svg-selector [svgName]="'green-star-big'"></svg-selector>
      <svg-selector [svgName]="'green-star-big'"></svg-selector>
      <svg-selector [svgName]="'green-star-big'"></svg-selector>
      <svg-selector [svgName]="'green-star-big'"></svg-selector>
    </div>
  </a>

  <div id="tp-widget-wrapper" class="tp-widget-wrapper visible" style="display: flex; justify-content: center;">
    <a id="profile-link" target="_blank" href="{{ lang !== 'en' ? '/' + lang : ''}}/reviews">
      <div style="display:inline-block;font-size: 13px;" id="tp-widget-rating" class="tp-widget-rating">
        <span id="translations-main">{{ 'with_over' | translate: lang }} <strong>179,000+</strong> {{ 'customer_reviews' | translate: lang }}</span>
      </div>
    </a>
  </div>
</div>